{
  "post-office.rovo-chat-button.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat-button.onboarding-heading": [
    {
      "type": 0,
      "value": "Chat with Rovo AI"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-1": [
    {
      "type": 0,
      "value": "Pick a conversation starter or ask Rovo anything"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-2": [
    {
      "type": 0,
      "value": "Write a prompt"
    }
  ],
  "post-office.rovo-chat-button.send-prompt": [
    {
      "type": 0,
      "value": "Send prompt"
    }
  ],
  "post-office.rovo-chat-recommended-spaces-spotlight.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat-spaces-spotlight.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.connect-button": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.heading": [
    {
      "type": 0,
      "value": "Your admin has added "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.logo-alt": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " logo"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.subtitle": [
    {
      "type": 0,
      "value": "Connect your account to see more results"
    }
  ],
  "post-office.rovo-chat.browse-prompt-gallery-spotlight.body": [
    {
      "type": 0,
      "value": "Explore a library of Rovo prompts you can plug into your everyday work, or create your own."
    }
  ],
  "post-office.rovo-chat.browse-prompt-gallery-spotlight.headline": [
    {
      "type": 0,
      "value": "Browse prompt library"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.body": [
    {
      "type": 0,
      "value": "Max takes on complex, multi-step work and comes back with a finished result."
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.headline": [
    {
      "type": 0,
      "value": "Say hi to Max"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body": [
    {
      "type": 0,
      "value": "Max takes on complex, multi-step work and comes back with a finished result."
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline": [
    {
      "type": 0,
      "value": "Meet Max. It handles everything."
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.action": [
    {
      "type": 0,
      "value": "See how"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Rovo now remembers facts and details from your chats to make responses more personalized and helpful"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.headline": [
    {
      "type": 0,
      "value": "A more personalized Rovo"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.button.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.button.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.button.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.button.step1": [
    {
      "type": 0,
      "value": "Show me what it means"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step1.body": [
    {
      "type": 0,
      "value": "A central place for context, docs, notes, and shared knowledge."
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step1.headline": [
    {
      "type": 0,
      "value": "Discover spaces"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step2.body": [
    {
      "type": 0,
      "value": "Think of it as shared context for the space. Rovo can use this context to provide answers that are more specific and relevant to the topic."
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step2.headline": [
    {
      "type": 0,
      "value": "What this space means"
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step3.body": [
    {
      "type": 0,
      "value": "Create a custom space from scratch and shape it around your workflow."
    }
  ],
  "post-office.rovo-chat.spaces-spotlight.step3.headline": [
    {
      "type": 0,
      "value": "Couldn’t find the right one?"
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.body": [
    {
      "type": 0,
      "value": "Turn on Think Deeper for deeper, more nuanced answers to complex questions."
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.dismiss": [
    {
      "type": 0,
      "value": "Turn on Think Deeper"
    }
  ],
  "post-office.rovo-chat.think-deeper-spotlight.headline": [
    {
      "type": 0,
      "value": "Let Rovo think it through"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.body": [
    {
      "type": 0,
      "value": "We're running an experiment to improve Rovo. For some users, web search is now on by default—you can turn it off any time."
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.dismiss": [
    {
      "type": 0,
      "value": "Turn off default web search"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.headline": [
    {
      "type": 0,
      "value": "Web search is now on by default"
    }
  ],
  "rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Rovo has completed your scheduled query"
    }
  ],
  "rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "Rovo is awaiting your response"
    }
  ],
  "rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Rovo has completed your task"
    }
  ],
  "rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "Rovo has generated your plan"
    }
  ]
}